import { useMutation } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';

const UPDATE_JOB_COMMENT = gql`
  mutation UpdateJobComment($input: JobCommentUpdateInput!) {
    updateJobComment(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/UpdateJobComment').type;
export type UpdateJobCommentVariables = OperationVariables<
  typeof UPDATE_JOB_COMMENT
>;
export type UpdateJobCommentResult = OperationData<typeof UPDATE_JOB_COMMENT>;
export type UpdateJobCommentItem = NonNullable<
  UpdateJobCommentResult['updateJobComment']
>;

export const useUpdateJobComment = () => {
  const tuple = useMutation(UPDATE_JOB_COMMENT);

  const [_mutate, result] = tuple;

  const mutate = (options: Parameters<typeof _mutate>[0]) =>
    _mutate({
      context: { service: 'core' },
      refetchQueries: ['GetJobComments'],
      awaitRefetchQueries: true,
      ...options,
    });

  return [mutate, result] as const;
};
